import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import BatchContext from '../../BatchContext';
import { Link } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import MuiLink from '@material-ui/core/Link';
import Property from '../../../../Property';
import { boolean as booleanFormatter } from '@afosto/app-components-react/DataGrid/formatters';
import camelize from '@afosto/utils/string/camelize';
import translations from './translations';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import arrayFromNumber from '@afosto/utils/array/arrayFromNumber';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const FILES_APP_ORIGIN = BASE_URL.replace('{app}', 'files');

const BatchProperties = ({ isLoading }) => {
  const intl = useIntl();
  const { batch, dataset } = useContext(BatchContext);

  const renderDataSetLink = () => {
    const isSameOrigin = window.location.origin === FILES_APP_ORIGIN;

    if (!dataset) {
      return undefined;
    }

    if (isSameOrigin) {
      return (
        <MuiLink variant="body2" component={Link} to={`/datasets/${dataset?.id}`}>
          {dataset?.reference ?? '-'}
        </MuiLink>
      );
    }

    return (
      <MuiLink variant="body2" href={`${FILES_APP_ORIGIN}/datasets/${dataset?.id}`}>
        {dataset?.reference ?? '-'}
      </MuiLink>
    );
  };

  if (isLoading) {
    return (
      <Card>
        <CardContent>
          {arrayFromNumber(8).map(key => (
            <Property
              key={key}
              label={<SkeletonBody lines={1} style={{ width: '10rem', marginBottom: '.75rem' }} />}
              value={<SkeletonBody lines={1} style={{ width: '5rem', marginBottom: '2rem' }} />}
            />
          ))}
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        <Property
          label={intl.formatMessage(translations.properties.reference)}
          value={batch?.reference}
        />

        <Property
          label={intl.formatMessage(translations.properties.action)}
          value={intl.formatMessage({
            id: `batchActions.${camelize(batch?.action_id ?? '')}`,
            defaultMessage: batch?.action_id ?? '',
            description: 'Title of the batch action',
          })}
        />

        <Property
          label={intl.formatMessage(translations.properties.dataset)}
          value={dataset?.reference && renderDataSetLink()}
        />

        <Property
          label={intl.formatMessage(translations.properties.isImport)}
          value={booleanFormatter(batch?.is_import)}
        />

        <Property
          label={intl.formatMessage(translations.properties.isAccepted)}
          value={booleanFormatter(batch?.is_accepted)}
        />

        <Property
          label={intl.formatMessage(translations.properties.isConfirmed)}
          value={booleanFormatter(batch?.is_confirmed)}
        />

        <Property
          label={intl.formatMessage(translations.properties.isReady)}
          value={booleanFormatter(batch?.is_ready)}
        />

        <Property
          label={intl.formatMessage(translations.properties.isFailing)}
          value={booleanFormatter(batch?.is_failing)}
        />
      </CardContent>
    </Card>
  );
};

BatchProperties.propTypes = {
  isLoading: PropTypes.bool,
};

BatchProperties.defaultProps = {
  isLoading: false,
};

export default BatchProperties;
